const reverseString = (str: string) => {
  return str.split('').reverse().join('');
};

export default reverseString;
